import { sendCarriage } from "~/features/configurator/Carriage/api/sendCarriageCommon";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";
import { transform } from "~/features/configurator/Linear/linearDataTransformer";
import { getMainKmat } from "~/features/configurator/Shaft/common/commonShaftHelpers";
import { FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE } from "~/features/configurator/Carriage/carriageConfiguratorConstants";
import { isNonNull } from "~/common/utils/reducers";
import { buildConfiguratorNavigationCommand } from "~/features/configurator/common/api/configuratorCommands";

export async function sendCarriageStepChange(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const response = await sendCarriage(buildConfiguratorNavigationCommand(linearState));

  const oldCstics = getMainKmat({ kmats: linearState.kmats }).cstics;
  const csticsToPreserve = [FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE].map((name) => oldCstics[name]).filter(isNonNull);

  return transform(response, ConfiguratorType.Carriage, csticsToPreserve);
}
